import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Key used to decide whether two subject/from lines are the same line.
 * Case and stray whitespace differ constantly in spreadsheet copy-paste, so
 * neither is enough on its own to make a line count as new.
 */
export function lineKey(description: string): string {
  return description.trim().replace(/\s+/g, " ").toLowerCase()
}
